var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPortalAluno18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.183 4.39928H11.5109L14.4653 1.49355C14.8134 1.15212 14.8134 0.597126 14.4653 0.255702C14.1171 -0.0857222 13.554 -0.0857222 13.2059 0.255702L9.49928 3.9024L5.7927 0.257155C5.44454 -0.0842693 4.88146 -0.0842693 4.53329 0.257155C4.18513 0.598579 4.18513 1.15357 4.53329 1.495L7.48767 4.40073H4.81698C2.15776 4.39928 0.00143277 6.51902 0 9.13418V12.2622C0 14.8788 2.15632 17 4.81698 17H14.183C16.8437 17 19 14.8788 19 12.2622V9.13418C18.9971 6.51902 16.8422 4.39928 14.183 4.39928ZM17.2191 12.2666C17.2176 13.9156 15.8594 15.2508 14.183 15.2522H4.81698C3.1392 15.2508 1.78094 13.9127 1.78094 12.2622V9.13418C1.78523 7.48663 3.1435 6.15435 4.81698 6.15144H14.183C15.8594 6.15289 17.2176 7.48953 17.2191 9.13854V12.2666ZM12.127 9.77344L9.14682 7.99513C8.36023 7.52149 7.28278 8.01402 7.28278 8.84361V12.4017C7.28278 13.2313 8.35736 13.7209 9.14682 13.2502L12.1284 11.4718C12.8147 11.0607 12.8147 10.1831 12.127 9.77344Z",
    fill: "#FF9239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPortalAluno18);
export default __webpack_public_path__ + "static/media/ic_portal_aluno-18.a902f3137a7351d04b3b01cc66eec931.svg";
export { ForwardRef as ReactComponent };